export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-web-09e31f23d2830898f09cbf7dfbbd2371.woff";